import { CartLinesUpdateEvent } from '@shopify/events';
/* LP1: Two purchased Matcha bags plus a free Strawberry Set.
   Markup kommt aus Liquid, hier steht nur Verhalten: Paket-Auswahl, Sortenbilder,
   Preis pro Portion, Geschenkbox, Warenkorb und die Sticky-Leiste.
   Der Assortion-Warenkorb oeffnet sich bei jedem /cart/add.js von selbst. */
(function () {
  'use strict';

  if (window.mlMittagHorizonOffer) return;
  window.mlMittagHorizonOffer = true;

  function euro(n) {
    return '€ ' + n.toFixed(2).replace('.', ',');
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    });
  }

  document.querySelectorAll('[id$=__reviews] ml-testimonials').forEach(function(el){el.id='kundenstimmen';});
  function initOffer(root) {
    if (root.dataset.mhInitialized) return;
    root.dataset.mhInitialized = 'true';
    var sw = root.querySelector('[data-ml-mt21-switch]');
    var atc = root.querySelector('[data-ml-mt21-atc]');
    if (!sw || !atc) return;

    var label = root.querySelector('[data-ml-mt21-atc-label]');
    var ppp = root.querySelector('[data-ml-mt21-ppp]');
    var error = root.querySelector('[data-ml-mt21-error]');
    var labelsTpl = root.querySelector('[data-ml-mt21-labels]');
    var bundleGiftCode = (root.getAttribute('data-gift-code') || '').trim();
    var singleGiftCode = (root.getAttribute('data-gift-code-single') || '').trim();
    var gifts = root.querySelector('[data-ml-mt21-gifts]');
    var GIFT_PROP = '_cro_gift';
    var basePrice = parseFloat(sw.getAttribute('data-base-price')) || 0;
    var portions = parseInt(sw.getAttribute('data-portions'), 10) || 30;
    var bundlePortions = parseInt(sw.getAttribute('data-bundle-portions'), 10) || portions * 2;
    var variantId = sw.getAttribute('data-variant-id');

    function selected() {
      var pack = sw.querySelector('.subscription-input:checked');
      if (!pack || pack.value === 'bundle') return 'bundle';
      return sw.querySelector('input[name^="ml-method-"]:checked')?.value || 'onetime';
    }

    function activePlanSelect() {
      var selects = sw.querySelectorAll('.selling_plan');
      for (var i = 0; i < selects.length; i++) {
        if (!selects[i].disabled) return selects[i];
      }
      return null;
    }

    function labelFor(value) {
      if (!labelsTpl) return '';
      var el = labelsTpl.content.querySelector('[data-for="' + value + '"]');
      return el ? el.textContent.trim() : '';
    }

    function update() {
      var value = selected();
      sw.querySelectorAll('[data-choice]').forEach(function (item) {
        item.classList.toggle('is-selected', item.dataset.choice === (value === 'bundle' ? 'bundle' : 'single'));
      });
      var selectedCard = sw.querySelector('[data-choice].is-selected');
      if (gifts && selectedCard) selectedCard.appendChild(gifts);
      sw.querySelector('[data-bags]').hidden = value !== 'bundle';
      var methods = sw.querySelector('[data-methods]');
      if (methods) methods.hidden = value === 'bundle';
      var planPanel = sw.querySelector('[data-plan-panel]');
      if (planPanel) planPanel.hidden = value !== 'subscription';
      var planSelect = sw.querySelector('.selling_plan');
      if (planSelect) planSelect.disabled = value !== 'subscription';
      var prices = Array.from(sw.querySelectorAll('.bundle-select')).map(function (select) {
        return Number(select.selectedOptions[0]?.dataset.price || basePrice * 100);
      });
      if (prices.length === 2) {
        var actual = prices.reduce(function (sum, price) { return sum + price; }, 0);
        var money = function (cents) { return new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR', minimumFractionDigits:cents % 100 ? 2 : 0}).format(cents/100); };
        sw.querySelector('[data-bundle-price]').textContent = money(actual);
        sw.querySelector('[data-bundle-portion]').textContent = new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format(actual / (bundlePortions * 100)) + ' ' + (sw.dataset.portionLabel || '/ Portion');
      }
      if (planSelect && value === 'subscription') {
        var subPrice = Number(planSelect.selectedOptions[0].dataset.price);
        sw.querySelector('[data-subscription-price]').textContent = new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'}).format(subPrice/100);
        sw.querySelector('[data-subscription-portion]').textContent = new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'}).format(subPrice/3000) + ' / Portion';
      }

      var total = basePrice;
      var count = portions;
      if (value === 'bundle') {
        total = prices.reduce(function (sum, price) { return sum + price; }, 0) / 100;
        count = bundlePortions;
      } else if (value === 'subscription') {
        var plan = activePlanSelect();
        var tier = plan ? parseFloat(plan.getAttribute('data-discount-tier')) : 0;
        if (!isNaN(tier) && tier > 0 && tier < 100) total = basePrice * (1 - tier / 100);
      }
      if (ppp && count > 0 && total > 0) {
        ppp.textContent = 'nur ' + euro(total / count) + ' pro Portion';
      }
      var text = labelFor(value);
      if (label && text) label.textContent = text;
      updateGifts(value);
    }

    function giftTiles() {
      return gifts ? Array.prototype.slice.call(gifts.querySelectorAll('.mlg-tile')) : [];
    }

    function inSet(tile, value) {
      return (' ' + tile.getAttribute('data-sets') + ' ').indexOf(' ' + value + ' ') > -1;
    }

    /* Kachel aktiv: gehoert zur gewaehlten Option. Gesperrt: gibt es nur mit 2 Beuteln.
       Wird eine Kachel frei, springt sie kurz an (wie im CH-Skript). */
    function updateGifts(value) {
      if (!gifts) return;
      var any = false;
      giftTiles().forEach(function (tile) {
        var on = inSet(tile, value);
        var lockable = inSet(tile, 'bundle');
        var wasLocked = tile.classList.contains('is-locked');
        tile.hidden = !on;
        tile.classList.toggle('is-locked', !on);
        tile.classList.remove('is-unlocked');
        if (on && wasLocked) {
          void tile.offsetWidth;
          tile.classList.add('is-unlocked');
        }
        if (on) any = true;
      });
      gifts.hidden = !any;
      gifts.dataset.offer = value;
      var v = gifts.querySelector('[data-ml-mt21-gifts-value]');
      if (v) v.textContent = gifts.getAttribute('data-value-' + value) || '';
    }

    function giftVariants(value) {
      var ids = [];
      giftTiles().filter(function (t) { return inSet(t, value); }).forEach(function (t) {
        (t.getAttribute('data-variants') || '').split(' ').forEach(function (id) {
          if (Number(id)) ids.push(Number(id));
        });
      });
      return ids;
    }

    if (gifts) {
      gifts.addEventListener('click', function (e) {
        if (!e.target.closest('.mlg-tile.is-locked')) return;
        var bundle = sw.querySelector('.subscription-input[value="bundle"]');
        if (!bundle) return;
        bundle.checked = true;
        update();
      });
    }

    sw.addEventListener('change', function (e) {
      if (e.target.classList.contains('bundle-select')) {
        var img = e.target.closest('.bundle-item').querySelector('.bundle-img');
        var opt = e.target.options[e.target.selectedIndex];
        var src = opt && opt.getAttribute('data-img');
        if (img && src) { img.src = src; img.removeAttribute('srcset'); }
      }
      update();
    });

    function items() {
      var value = selected();
      if (value === 'bundle') {
        return Array.prototype.map.call(sw.querySelectorAll('.bundle-select'), function (s) {
          return { id: Number(s.value), quantity: 1 };
        });
      }
      var item = { id: Number(variantId), quantity: 1 };
      if (value === 'subscription') {
        var plan = activePlanSelect();
        if (plan && plan.value) item.selling_plan = Number(plan.value);
      }
      return [item];
    }

    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      var value = selected();
      atc.disabled = true;
      atc.classList.add('loading');
      if (error) error.hidden = true;

      var wanted = giftVariants(value);
      var giftsInCart = false;
      var existingCodes = [];

      /* Geschenke, die schon als Geschenk im Warenkorb liegen, nicht doppelt legen. */
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var have = {};
          existingCodes = (cart.discount_codes || []).map(function (d) { return d.code; });
          (cart.items || []).forEach(function (it) {
            if (it.properties && it.properties[GIFT_PROP]) have[it.variant_id] = true;
          });
          var list = items();
          wanted.forEach(function (id) {
            giftsInCart = true;
            if (have[id]) return;
            var props = {};
            props[GIFT_PROP] = 'geschenk';
            list.push({ id: id, quantity: 1, properties: props });
          });
          return postJson('/cart/add.js', { items: list });
        })
        .then(function () {
          /* Erst nach dem Hinzufuegen, ein Code auf leerem Warenkorb wird verworfen.
             /cart/update.js ersetzt alle Codes, darum beide zusammen schicken. */
          var codes = existingCodes.slice();
          var giftCode = value === 'bundle' ? bundleGiftCode : singleGiftCode;
          if (giftsInCart && giftCode) codes.push(giftCode);
          codes = codes.filter(function (item, index) { return codes.indexOf(item) === index; });
          return postJson('/cart/update.js', { discount: codes.join(','), sections: Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(function(el){return el.dataset.sectionId;}).filter(function(v,i,a){return a.indexOf(v)===i;}).slice(0,5), sections_url: window.location.pathname });
        })
        .then(function (cart) {
          if (root.dataset.directCheckout === 'true') {
            window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
            return;
          }
          var deferred = CartLinesUpdateEvent.createPromise();
          atc.dispatchEvent(new CartLinesUpdateEvent({ action:'add', context:'product', lines:[{merchandiseId:variantId,quantity:value==='bundle'?2:1}], promise:deferred.promise }));
          deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:root.id,itemCount:value==='bundle'?2:1,productId:sw.dataset.productId,sections:cart.sections,didError:false}});
        })
        .catch(function (err) {
          if (window.console) console.error('[ml-mt21]', err);
          if (error) error.hidden = false;
        })
        .then(function () {
          atc.disabled = false;
          atc.classList.remove('loading');
        });
    });

    update();
  }

  /* Leiste erscheint, sobald der Hero aus dem Bild ist, und verschwindet,
     solange ein Angebots-Block selbst zu sehen ist. */
  function initSticky(bar) {
    if (!('IntersectionObserver' in window)) return;
    var offers = document.querySelectorAll('.ml-lp1-offer');
    var visible = [];
    var pastTop = false;

    function render() {
      bar.hidden = !(pastTop && visible.length === 0);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = visible.indexOf(en.target);
        if (en.isIntersecting && i < 0) visible.push(en.target);
        if (!en.isIntersecting && i >= 0) visible.splice(i, 1);
      });
      render();
    });
    offers.forEach(function (el) { io.observe(el); });
    var footer = document.querySelector('footer');
    if (footer) io.observe(footer);

    function onScroll() {
      pastTop = window.pageYOffset > window.innerHeight * 0.9;
      render();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    bar.querySelector('a').addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.getElementById(decodeURIComponent(href.slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-ml-mh-offer]').forEach(initOffer);
    var bar = document.querySelector('[data-ml-mt21-sticky]');
    if (bar) {
      document.body.appendChild(bar);
      initSticky(bar);
    }
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();




